exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-home-___style__header___3puof{margin:0 1rem}.web-flows-home-___style__list___2hFNj{display:flex;width:100%;flex-wrap:wrap}.web-flows-home-___style__list___2hFNj>div{flex:1;min-width:200px;max-width:300px;margin:1em}", ""]);

// exports
exports.locals = {
	"header": "web-flows-home-___style__header___3puof",
	"list": "web-flows-home-___style__list___2hFNj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/home/style.css
// module id = 1353
// module chunks = 0